<template>
  <span>
    <template v-if="hasSlug">
      <a-tooltip>
        <template slot="title">
          {{ $t("common.show_in_synthetic") }}
        </template>

        <a
          :href="productUrl"
          target="_blank"
        >
          <a-icon
            type="link"
            :style="{ marginRight: hasSlot('content') ? '4px' : '0' }"
          />
          <slot
            v-if="hasSlot('content')"
            name="content"
          />
          <span v-else>
            {{ code }}
          </span>
        </a>
      </a-tooltip>
    </template>

    <template v-else>
      <slot
        v-if="hasSlot('content')"
        name="content"
      />
      <span v-else>
        {{ code }}
      </span>
    </template>
  </span>
</template>

<script lang="ts">
type ProductUrl = null | string

export default {
  name: "ProductCode",

  props: {
    code: {
      type: String,
      required: true
    },

    slug: {
      type: String,
      required: false
    }
  },

  methods: {
    hasSlot(slotName): boolean {
      return slotName in this.$slots
    }
  },

  computed: {
    hasSlug(): boolean {
      return !!this.slug
    },

    productUrl(): ProductUrl {
      const { hasSlug, slug, code } = this

      return hasSlug
        ? `${new URL(process.env.VUE_APP_MARKETPLACE_URL).origin}/product/${slug}/${code}`
        : null
    }
  }
}
</script>
